import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './AddEditLevelModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'
import useLocalization from 'hooks/useLocalization'

const AddEditLevelModal = () => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  const handleInputChange = (e) => {
    const { value } = e.target
    changeValue(value, 'name')
  }

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'lvls',
    dict: {
      levels_for_clients: 'Levels for clients',
      entries: 'Entries',
      level_name: 'Level name',
      min_lessons_required:
        'Minimum number of lessons required to obtain this level',
      edit: 'Edit',
      delete: 'Delete',
      add_level: 'Add level',
      enter_name: 'Enter the name',
      edit_level: 'Edit level',
      are_you_sure: 'Are you sure',
      are_you_sure_delete_level: 'Are you sure you want to delete the level',
    },
  })

  return (
    <div className={st.fieldSet}>
      <FormField>
        <FormLabel isRequired>{translate.level_name}:</FormLabel>
        <FormInput isError={check('name')}>
          <input
            type='text'
            placeholder={translate.enter_name}
            name='name'
            value={modalValue?.name || ''}
            onChange={handleInputChange}
            maxLength={60}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>{translate.min_lessons_required}:</FormLabel>
        <FormInput isError={check('finished_lessons_count')}>
          <input
            type='number'
            placeholder={translate.min_lessons_required}
            value={modalValue?.finished_lessons_count || ''}
            onChange={(e) =>
              changeValue(e.target.value, 'finished_lessons_count')
            }
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default observer(AddEditLevelModal)
